import { IAppState } from '../appState';
import { StateV7 } from './7_migrate_kooperations-nachlass.interface';

export const migrateKooperationsNachlass = (
  previousState: StateV7,
  newVersion: number,
  currentState: IAppState,
): StateV7 => {
  const foundKooperation = currentState.transientState.kooperationen?.some(
    k => k?.code === previousState.vertragsoptionen?.selectedKooperation,
  );

  if (!foundKooperation) {
    delete previousState.vertragsoptionen?.selectedKooperation;
  }
  return {
    ...previousState,
    version: newVersion,
  };
};
